import { useEffect } from 'react';
import { ColumnSubType } from '@scale/compass-shared/types';
import type { ExplainQueueContext } from '@scale/genai-compass-shared/cards/explain_queue';
import { useCompassCard } from '@scale/compass-ui/store';

function useExplainQueueCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit } = useCompassCard(index);
  const context = card.defaultContext as ExplainQueueContext;
  const { retrievedOutput } = useCompassCard(index - 1);
  const data = retrievedOutput?.response?.data ?? [];
  const columns = retrievedOutput?.response?.schema ?? [];

  const setSelectedColumnId = (selectedColumnId: string) => {
    if (selectedColumnId) {
      updateCardContext({
        ...context,
        selectedColumnId,
      } as ExplainQueueContext);

      updateCardCanSubmit(true);
    }
  };

  const setProjectId = (projectId: string) => {
    if (projectId) {
      updateCardContext({
        ...context,
        projectId,
      } as ExplainQueueContext);
    }
  };

  useEffect(() => {
    // Try to set column with worker IDs as default.
    for (const column of columns) {
      if (column.subType === ColumnSubType.WORKER_ID) {
        setSelectedColumnId(column.id);
        break;
      }
    }
  }, [columns]);

  return {
    selectedColumnId: context.selectedColumnId,
    setSelectedColumnId,
    projectId: context.projectId,
    setProjectId,
    data,
    columns,
    card,
  };
}

export default useExplainQueueCard;
